import React, {useState, useEffect, useMemo} from 'react'
import {Row, Col, Form, Card, Button, Divider, Checkbox, Spin, Tooltip, Modal, Select} from 'antd'
import { connect } from 'react-redux'

import InputField from 'components/InputField'
import TextAreaField from 'components/TextArea'
import SelectField from 'components/SelectField'
import FileUpload from 'components/fileUpload'

import {
    SaveIco,
    SaveBlueIco,
    RefreshIco,
    SearchIco,
    MinusSmallIco,
    PlusSmallIco,
    SpinnerIco,
    TabsInfoIco,
    CheckGreenIco,
    CancelRedIco,
    ModalCloseIco, InputSearchIco, SuccessIconLimit, ErrorLimitIcon,
    EroorIco,
} from "../../../../../modules/CustomIcons"


import './index.scss'
import '../../transfer.scss'
import {OWNACCOUNT} from "constants/constants";
import {Account, getAccounts, getSavedDocuments} from "../../../../services/account";
import {SelectOptions} from "../../../../services/form";
import {getCurrentCompany, getUserData} from "../../../../services/user";
import {
    checkAmountForRequest,
    fillCurrentForm,
    fillCurrentFormTemplate,
    financial,
    resetForm
} from "../../../../services/helper";
import AmountField from "components/AmountField";
import NextModal from "components/NextModal";
import {
    BankCodes,
    getBankCodes,
    getClassificationCodes, getLevelCodes,
    getTeskilatCodesByFilter
} from "../../../../services/moneytransfer";
import TemplatePopup from "components/TemplatePopup";
import {getCustomerCommission} from "../../../../services/Customers/Commission";
import SaveAsTemplate from "components/SaveAsTemplate";
import {useLocation} from "react-router-dom";
import {setIbanNumber } from "../../../../store/actions/accountStatement";
import { useActions } from 'hooks/useActions'
import { useTranslation } from 'react-i18next'
import {
    benefBankAccCheck,
    checkLimit,
    cutOffService,
    getInfoByAlias, IpsNewTransfer,
    receiverDetail
} from "../../../../services/Transfers/transfers";
import {
    getAzipsDocumentNumber,
    getIpsNonBdgDocumentNumber,
} from "../../../../services/Accounts/DocumentNumber";
import LimitsModal from "components/LimitsModal/LimitsModal";
import {newMoneyTransferDxa} from "../../../../services/Transfers/Dxa";
import FullScreenLoading from "components/FullScreenLoading";
import InputAniPay from './inputanipay'
import {getMessageList} from "../../../../services/info";
import {deleteFileById} from "../../../../services/Transfers/Files";
import debounce from 'lodash.debounce'




const QeyriBudce: React.FC<any> = ({ ownProps, ibanNumber }) => {
    const {t} =useTranslation()
    const aliasList= [
        {
            label : t("login.mobileNumber"),
            code:'MOBILE',
            value: 1,
        },
        {
            label : t("requisites.PIN"),
            code:'PIN',
            value: 2,
        },
        {
            label : t("requisites.taxID"),
            code:'TIN',
            value: 3,
        },
        {
            label : 'IBAN',
            code:'IBAN',
            value: 4,
        },
        {
            label : t("requisites.email"),
            code:'email',
            value: 5,
        },
        {
            label : 'Merchant ID',
            code:'MERCHANTID',
            value: 6,
        },
        {
            label : t("requisites.Objectcode"),
            code:'OBJECTCODE',
            value: 7,
        },
    ];
    const [nextModalNote,setNextModalNote] = useState('')
    const [alertText,setAlertText] = useState('')
    const modalDataInitial= {
        modalTitle : 'AniPay - Qeyri-büdcə',
        groups: [
            {
                title: false,
                data: []
            }
        ],
        note : nextModalNote,
        pdfFiles : [],
        buttons : [
            {save : true},
            {sign : true},
            {approve : true},
            {send : true}
        ],
        alertText: alertText,
    }
    const [optionsDet, setOptionsDet] = useState<any[]>([])

    const language = localStorage.getItem("i18nextLng")
    const [visible, setVisible] = useState(false);
    const [aliasStatus, setAliasStatus] = useState(false);
    const [message,setMessage]= useState('')
    const [selectedAlias, setSelectedAlias] = useState<any>(null);
    const [inputType, setInputType] = useState('-');
    const [inputValue, setInputValue] = useState('');
    const [inputMask, setInputMask] = useState('');
    const [inputPlaceholder, setInputPlaceholder] = useState('');
    const [inputPrefix, setInputPrefix] = useState<any>('');
    const [inputMaxLength, setInputMaxLength] = useState<any>(false);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [nextModalVisible, setNextModalVisible] = useState(false);
    const [retryRequest, setRetryRequest]=useState(null);
    const [templatePopupVisible, setTemplatePopupVisible] = useState(false);
    const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] = useState<boolean>(false);
    const [allAccounts, setAllAccounts]=useState([]);
    const [fromSelectOptions, setFromSelectOptions]=useState<SelectOptions[]>();
    const [fromBranch, setFromBranch]=useState<Account>();
    const [inputDisabled, setInputDisabled]=useState(true);
    const [codeModalVisible, setCodeModalVisible] = useState(false);
    const [bankCodes, setBankCodes]=useState<BankCodes>();
    const [allBankCodes, setAllBankCodes]=useState<BankCodes>();
    const [formFields, setFormFields]=useState({});
    const [commissionLoading, setCommissionLoading]=useState(false);
    const [commissionAmount, setCommissionAmount]=useState('');
    const [commissionAmountModal, setCommissionAmountModal]=useState('');
    const [amountModal,setAmountModal] = useState('')
    const [isDisabled,setIsDisabled] = useState(true)
    const [custAcc,setcustAcc] = useState('')
    const [statusLimit,setStatusLimit] = useState('')
    const [documentNo,setDocumentNo] = useState('')
    const [bankTaxId,setBankTaxId] = useState('')
    const [bankCorAcc,setBankCorAcc] = useState('')
    const [bankSwift,setBankSwift] = useState('')
    const [getbyAlias,setGetbyAlias] = useState('N')
    const [limitModal,setlimitModal] = useState(false)
    const [typeTransfer,setTypeTransfer] = useState('')
    const [amountTransfer,setAmountTransfer] = useState('')
    const [cariCount,setCariCount] = useState('')
    const [sendCariCount,setSentCariCount] = useState('')
    const [cariTotalAmount,setCariTotalAmount] = useState('')
    const [limitTotalAmount,setLimitTotalAmount] = useState('')
    const [modalNote,setModalNote] = useState('')
    const [modal2ndtitle,set2ndTitle]= useState('')
    const [currency,setCurrency] = useState('')
    const [fileList, setFileList] = useState([])
    const [fileUp, setFileUp] = useState<any[]>([])
    const [disabledSign,setdisabledSign] = useState(false)
    const [aliaserrorMessage,setAliasError] = useState('')
    const [commCode,setCommCode] = useState('')
    const [loadingAccount, setLoadingAccount] = useState(false);
    const [loadinglimit,setLoadingLimit] = useState(false)
    const [disableCode,setDisableCode] = useState(false)
    const [loadingData, setLoadingData] = useState(false);
    const [accMessage,setAccMessage] = useState(null)
    const [loadtempbutton,setLoadtempbutton] = useState(false)
    const [amountField, setAmount] = useState();
    const [getByTemp,setGetbyTemp] = useState("N")
    const [tempName,setTempName] =useState('')
    const [modalData, setModalData] = useState(modalDataInitial);
    const [ibankRef, setIbankRef] = useState<string>('');
    const [loadingNext,setLoadingNext]= useState(false)
    const [maindetail,setMainDet] = useState<any>('')
    const [isTouched, setIsTouched] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [dropListLoading, setDropListLoading]= useState(false);
    const [form] = Form.useForm();
    const location=useLocation();
    const { setIbanNumber } = useActions();
    const addOrEditPage = ownProps?.addOrEditPage || false;
    let messageCutOff = "";
    let alertmessage = ''
    let status_Limit =''
    var limitMessage =''
    const modalDataLimit = {
        modalTitle : t('businessCards.limits'),
        note:modalNote,
        type:statusLimit,
        icon:statusLimit==="success"?<SuccessIconLimit/>:<ErrorLimitIcon/>,
        groups : [
            {
                title : false,
                tableHasBorderBottom : true,
                data : [
                    {
                        label : t("transfers.transfersType"),
                        value : typeTransfer
                    },
                    {
                        label : t("transfers.transfersAmount"),
                        value : amountModal
                    },
                    {
                        label : t("transfers.comAmount"),
                        value : commissionAmountModal
                    }
                ]
            },
            {
                title : modal2ndtitle,
                tableHasBorderBottom2 : false,
                tableHasMarginBottom : false,
                data : [
                    {
                        label : t('transfers.transactionsNum'),
                        value : sendCariCount
                    },
                    {
                        label : t('transfers.transactionsTotNum'),
                        value : amountTransfer
                    },
                    {
                        label : t('transfers.allowableToSendNum'),
                        value : cariCount
                    },
                    {
                        label : t('transfers.allowableToSendAmount'),
                        value : cariTotalAmount
                    },
                    {
                        label : t('transfers.totalLimitTransAmount'),
                        value : limitTotalAmount
                    }
                ]
            },

        ],
        pdfFiles : [],
        buttons : [
            {save : true},
            {sign : true},
            {approve : true},
            {send : true}
        ]
    }

    const updateBankCodes = async (modalVisible : boolean = true) => {
        const typed_code=form.getFieldValue('BENEFBANKCODE') || '';
        const typed_name=form.getFieldValue('BENEFBANKNAME')?.toString()?.toLowerCase() || '';

        if (typed_code.length >= 2 || typed_name.length >= 3){
            const data = !allBankCodes ? await getBankCodes() : allBankCodes;

            setAllBankCodes(old_data => data);

            const filter_codes=data?.filter(row =>
                typed_code && typed_name ? row.CODE.includes(typed_code) && row.NAME.toString().toLowerCase().includes(typed_name) :

                    typed_code ? row.CODE.includes(typed_code) : typed_name ? row.NAME.toString().toLowerCase().includes(typed_name) : row
            );

            setFormFields(old_data => ({
                ...old_data,
                BENEFBANKCODE : typed_code,
            }))

            setBankCodes(old_data => filter_codes);
        }

        setCodeModalVisible(modalVisible);
    }

    const updateToBankCodeAndName = (row) => {

        setFormFields(old_data => ({
            ...old_data,
            BENEFBANKCODE : row.CODE,
            BENEFBANKNAME : row.NAME,
        }))

        setCodeModalVisible(false);
    }

    const fetchData = async () => {
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());
        const new_data = data.filter(row=>row.CCY_NAME == "AZN")

        let temp_data=[];

        for (let row of new_data ){
            if(row.STATUS !== "0") {

                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.ACCOUNT_NO,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
            // @ts-ignore

        }

        setAllAccounts(new_data);
        setFromSelectOptions(old_data => temp_data);

        /**/
        if (location?.state?.trnData){
            fillCurrentForm(form, location.state.trnData)
        }
        setIsDisabled(true)
        setLoadingAccount(false);
    };

    const fetchDataDropList = async () => {
        setDropListLoading(true)
        const data = await getMessageList();
        let temp_data=[];
        if(data.messageList !== undefined && data.messageList !== null && data.messageList.length > 0) {
            for (let row of data.messageList) {
                if (row.messageKey.toString().includes("DROP.ALL")) {
                    // @ts-ignore
                    let labelText;
                    switch(language) {
                        case 'az':
                            labelText = row.textAZE;
                            break;
                        case 'ru':
                            labelText = row.textRU;
                            break;
                        case 'en':
                            labelText = row.textENG;
                            break;
                        default:
                            labelText = row.textAZE;
                    }

                    temp_data.push({
                        label: labelText,
                        value:  labelText,
                    });
                }
            }
        }
        setDropListLoading(false)
        console.log(temp_data)
        setOptionsDet(old_data => temp_data);

    };


    useEffect(() => {
        fetchDataDropList();
        console.log("da",location.state);
        if (location.state?.data)
            loadData()
        else if (location.state?.trnData)
            loadDataTemplate2(location.state)
        else {
            fetchData();
        }

    }, [location.state]);

    const loadData = async () => {
        console.log('loadDataishledi')
        setLoadingData(true)
        const pdf = await getSavedDocuments(location.state?.data['ibankRef'])
        console.log("pd",pdf);
        
        setFileList(pdf.data?.fileDetailsList)
        setDisableCode(true)
        setGetbyTemp('Y')
        setTempName(location.state?.data['TEMPLATE'].TEMPLNAME)

        if(location.state?.edit)
            setIbankRef(location.state?.data['ibankRef'])
        // load Account
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());
        let temp_data = [];
        for (let row of data) {
            if (row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        setLoadingAccount(false);
        // const pdf = await getSavedDocuments(location.state?.data['ibankRef'])



        // CUSTACC
        const findAccount = data?.find(row => row.IBAN == location.state?.data['CUSTACC']);
        if (findAccount !== undefined) {
            setIsDisabled(false)
            setFromBranch(findAccount);
            if ((form.getFieldValue('PMTID') === "" || form.getFieldValue('PMTID') === undefined) && location.state?.edit === undefined) {
                updateDocumentNumber();
            } else if (location.state?.edit) {
                form.setFieldsValue({
                    'PMTID': location.state?.data['PMTCUSTID']
                });
            }

            form.setFieldsValue({
                'CUSTACC': findAccount.IBAN
            });
        }
        //ALIAS
        if(location.state?.data['ALIAS'].ALIASVALUE !==null && location.state?.data['ALIAS'].ALIASVALUE !== '' && location.state?.data['ALIAS'].ALIASVALUE !== undefined){
            chooseAlisa(location.state?.data['ALIAS'].ALIASTYPE)
                setInputType(location.state?.data['ALIAS'].ALIASTYPE)
                setSelectedAlias(aliasList.filter((row)=>row.code === location.state?.data['ALIAS'].ALIASTYPE)[0].value)
                form.setFieldsValue({
                    'alias_type':aliasList.filter((row)=>row.code === location.state?.data['ALIAS'].ALIASTYPE)[0].label
                })
                //ALIASVALUE
                form.setFieldsValue({
                    'alias_value':location.state?.data['ALIAS'].ALIASVALUE
                })
                getInfoByAlias({
                    PMTTYPECODE: "PI",
                    PMTID: location.state?.data['PMTCUSTID'],
                    CREATEDFROMTEMPL: "N",
                    TEMPLATE: {
                        TEMPLNAME: ''
                    },
                    ALIAS: {
                        ALIASTYPE:location.state?.data['ALIAS'].ALIASTYPE,
                        ALIASVALUE: location.state?.data['ALIAS'].ALIASVALUE
                    },
                    CUSTACC: findAccount?.IBAN
                },language).then(res=>{
                    if(res.ALIASRESULT==='Failure'){
                        setdisabledSign(true)
                        setInputDisabled(false)
                        setAliasError(res.ALIASREMARK)
                        form.setFieldsValue({
                            'BENEFNAME':'',
                            'BENEFBANKNAME':'',
                            'BENEFACC': '',
                            'BENEFBANKCODE':'',
                            'BENEFTAXID':'',


                        })
                        setInputValue('')
                        setGetbyAlias("N")
                    }

                    if(res.ALIASRESULT!=='Failure'){
                        form.setFieldsValue({
                            'BENEFNAME':res.BENEFINFO?.BENEFNAME,
                            'BENEFBANKNAME':res.BENEFINFO?.BENEFBANKNAME,
                            'BENEFACC': res.BENEFINFO?.BENEFACC,
                            'BENEFBANKCODE':res.BENEFINFO?.BENEFBANKCODE,
                            'BENEFTAXID':res.BENEFINFO?.BENEFTAXID

                        })
                        receiverDetailsbyIban(res.BENEFINFO?.BENEFACC)
                        setBankTaxId(res.BENEFINFO?.BENEFBANKTAXID)
                        setBankCorAcc(res.BENEFINFO?.BENEFBANKCOREACC)
                        setBankSwift(res.BENEFINFO?.BENEFBANKSWIFT)

                        setGetbyAlias('Y')
                    }
                    setShowLoading(false)
                })

                setAliasStatus(true)
            }
        else{
            //BENEFACC
            if (location.state?.data['BENEFACC'] !== undefined && location.state?.data['BENEFACC'] !== null) {
                receiverDetailsbyIban(location.state?.data['BENEFACC'])
                form.setFieldsValue({
                    'BENEFACC':location.state?.data['BENEFACC'],
                    'BENEFNAME':location.state?.data['BENEFNAME'],
                    'BENEFTAXID':location.state?.data['BENEFTAXID'],
                    'BENEFBANKCODE':location.state?.data['BENEFBANKCODE'],
                    'BENEFBANKNAME':location.state?.data['BENEFBANKNAME'],
                })
            }
        }


        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(location.state?.data['PMTAMOUNT'])
        });
        // PMTDET
        // const firstFindedMain=location.state?.data['PMTDET'].substring(0, location.state?.data['PMTDET'].indexOf(' '))
        // console.log(optionsDet.filter(row=>row.label.startsWith(firstFindedMain)))
        // const filteredOptions= optionsDet.filter(row=>row.label.startsWith(firstFindedMain))
        // if(filteredOptions.length===0 || firstFindedMain.length===0) {
        //     form.setFieldsValue({
        //         'PMTDET': location.state?.data['PMTDET']
        //     });
        //     setMainDet('')

        //     form.setFieldsValue({
        //         'MAINDET': undefined
        //     });
        // }else{
        //     for(var item in filteredOptions){
        //         console.log(filteredOptions[item])
        //         console.log(location.state?.data['PMTDET'].includes(filteredOptions[item].label))
        //         if(location.state?.data['PMTDET'].includes(filteredOptions[item].label)){
        //             form.setFieldsValue({
        //                 'MAINDET': filteredOptions[item].label
        //             });
        //             setMainDet(filteredOptions[item].label)
        //             const pmtdet = location.state?.data['PMTDET'].replace(filteredOptions[item].label,'')
        //             form.setFieldsValue({
        //                 'PMTDET': pmtdet
        //             });

        //         }


        //     }
        // }
        //MAINDET
       

 
        console.log(form.getFieldValue("PMTDET"))

        // INFOTOBENEF
        // if((location.state?.data['INFOTOBENEF'] === undefined || location.state?.data['INFOTOBENEF'] === null || location.state?.data['INFOTOBENEF']=== "") && location.state?.data['PMTDET']?.length > 175) {
        //     console.log(location.state?.data['PMTDET']?.length)
        //     form.setFieldsValue({
        //         'INFOTOBENEF': location.state?.data['PMTDET']?.substring(175, location.state?.data['PMTDET'].length)
        //     });
        // } else {
        //     console.log(form.getFieldValue('PMTDET'))
        //     form.setFieldsValue({
        //         'INFOTOBENEF': location.state?.data['INFOTOBENEF']
        //     });
        // }
          form.setFieldsValue({
                        'INFOTOBENEF': location.state?.data['INFOTOBENEF']
                    });
                
        console.log(form.getFieldValue('PMTDET'))
        setcustAcc(findAccount?.IBAN)
        console.log(form.getFieldValue('PMTDET'))
        // COMISSION
        let valueA = checkAmountForRequest(location.state?.data['PMTAMOUNT']);
        console.log(form.getFieldValue('PMTDET'))
        if (!isNaN(valueA)) {
            setCommissionLoading(true);
            console.log(form.getFieldValue('PMTDET'))
            getCustomerCommission({
                PAYMENT_TYPE: "PI",
                CIF: getCurrentCompany().customerNo,
                CUSTACC: findAccount?.IBAN,
                AMOUNT: valueA,
                CUR: findAccount?.CCY_NAME,
                BENEFBANKCODE: location.state?.data['BENEFBANKCODE'],
                BENEFACC: location.state?.data['BENEFACC'],
                BENEFTAXID: location.state?.data['BENEFTAXID'],
                PMTDET: location.state?.data['PMTDET'],
            }).then(res => {
                setCommissionLoading(false);
                console.log(form.getFieldValue('PMTDET'))
                form.setFieldsValue({
                    'COMMAMOUNT': res.COM_AMOUNT ?? ''
                });
                setCommCode(res.CommCode ?? '')
                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
            })
        } else {
            setCommissionLoading(false);

            form.setFieldsValue({
                'COMMAMOUNT': ''
            });

            setCommissionAmount(old_value => '');
        }

        //MAINDET && PMTDET
        if(location.state?.data['mainDetail']!==undefined && location.state?.data['mainDetail']!==null && location.state?.data['mainDetail']!=='' ){
            form.setFieldsValue({
                'MAINDET': location.state?.data['mainDetail']
            });
            setMainDet(location.state?.data['mainDetail'])
            if(location.state?.data['PMTDET']?.includes(location.state?.data['mainDetail'])) {
                const PMTDETAILWithoutMainDet = location.state?.data['PMTDET'].replace(location.state?.data['mainDetail'], '').trim();
                console.log(
                    'isledi 560'
                )
                form.setFieldsValue({
                    'PMTDET':  PMTDETAILWithoutMainDet.length > 175 ? PMTDETAILWithoutMainDet.substring(0,175):PMTDETAILWithoutMainDet
                });

                if((location.state?.data['INFOTOBENEF'] === undefined || location.state?.data['INFOTOBENEF'] === null || location.state?.data['INFOTOBENEF']=== "") && PMTDETAILWithoutMainDet.length > 175) {
                    console.log(location.state?.data['PMTDET']?.length)
                    form.setFieldsValue({
                        'INFOTOBENEF': PMTDETAILWithoutMainDet?.substring(175, location.state?.data['PMTDET'].length)
                    });
                } else {
                   
                    form.setFieldsValue({
                        'INFOTOBENEF': location.state?.data['INFOTOBENEF']
                    });
                }
            }else{
                console.log(
                    'isledi 566'
                )
                form.setFieldsValue({
                    'PMTDET':location.state?.data['PMTDET']
                });
            }
        }else{
            if(location.state?.data['BENEFTAXID'] !== undefined && location.state?.data['BENEFTAXID'] !== null) {
                form.setFieldsValue({
                    'PMTDET': location.state?.data['PMTDET']
                });
                }else{
                form.setFieldsValue({
                    'PMTDET': location.state?.data['PMTDET'].length > 175 ?  location.state?.data['PMTDET'].substring(0,175): location.state?.data['PMTDET']
                });
                }
                form.setFieldsValue({
                    'MAINDET': undefined
                });
                setMainDet('')
                
        }
        setLoadingData(false)
        console.log(form.getFieldValue('PMTDET'))
    }

    const loadDataTemplate = async (tempData) => {
        console.log(tempData?.trnData)
        setLoadingData(true)
        setLoadtempbutton(true)
        setDisableCode(false)
        setAliasStatus(false)
        setSelectedAlias(null)
        setInputPlaceholder('')


        const docid = documentNo;

        form.resetFields();
        if (tempData?.trnData) {
            fillCurrentFormTemplate(form, tempData?.trnData)
            updateParentComponentFormData();

        }
        if (docid !== "" && docid !== undefined) {
            form.setFieldsValue({
                'PMTID': docid
            });
            setDocumentNo(old_value => docid)
        }
        // CUSTACC


        const findAccount = allAccounts?.find(row => row.IBAN === tempData?.trnData.CUSTACC || row.ACCOUNT_NO === tempData?.trnData.CUSTACC);

        if (findAccount !== undefined) {
            updateDocumentNumber()
            setFromBranch(findAccount);
            setIsDisabled(false)
            if (docid === "" || docid === undefined) {
                updateDocumentNumber();
            }
            form.setFieldsValue({
                'CUSTACC': findAccount?.IBAN
            });
        }

        // BENEFACC
        // if (tempData?.trnData.BENEFACC !== undefined && tempData?.trnData.BENEFACC !== null) {
        //     const dataBENEFACC = await getTeskilatCodesByFilter(tempData?.trnData.BENEFACC, '');
        //     if (dataBENEFACC !== undefined && dataBENEFACC.length > 0) {
        //         setFormFields(old_data => ({
        //             ...old_data,
        //             BENEFBANKCODE: dataBENEFACC[0].code,
        //             BENEFACC: dataBENEFACC[0].orgcode,
        //         }))
        //         setSelectedAccount(true);
        //     }
        // }


        //BENEFNAME

        form.setFieldsValue({
            'BENEFNAME': tempData?.trnData?.BENEFNAME
        });

        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(tempData?.trnData?.AMOUNT)
        });
        
        form.setFieldsValue({
            'NOTE': tempData?.trnData?.NOTE
        });


        // AMOUNT
        form.setFieldsValue({
            'INFOTOBENEF': tempData?.trnData?.INFOTOBENEF
        });
        // BENEFBANKCODE
        form.setFieldsValue({
            'BENEFBANKCODE': tempData?.trnData?.BENEFBANKCODE
        });

        // BENEFBANKNAME
        form.setFieldsValue({
            'BENEFBANKNAME': tempData?.trnData?.BENEFBANKNAME
        });
        // ALIASTYPE


        setTempName(tempData?.templateName)
        setcustAcc(findAccount?.IBAN)

        //ALIASCheck
        if(tempData?.trnData?.alias_value !== null && tempData?.trnData?.alias_type !== null && tempData?.trnData?.alias_value !== '' && tempData?.trnData?.alias_value !== undefined){
            if(typeof tempData?.trnData?.alias_type !== 'string'){

                chooseAlisa(tempData?.trnData?.alias_type)
                setInputType(aliasList[tempData?.trnData?.alias_type-1].code)
                setSelectedAlias(aliasList[tempData?.trnData?.alias_type-1].value)
                form.setFieldsValue({
                    'alias_type':aliasList[tempData?.trnData?.alias_type-1].value
                })
                //ALIASVALUE
                form.setFieldsValue({
                    'alias_value':tempData?.trnData?.alias_value
                })
                getInfoByAlias({
                    PMTTYPECODE: "PI",
                    PMTID: tempData?.trnData?.PMTID,
                    CREATEDFROMTEMPL: "Y",
                    TEMPLATE: {
                        TEMPLNAME: tempData?.templateName
                    },
                    ALIAS: {
                        ALIASTYPE:aliasList[tempData?.trnData.alias_type-1].code,
                        ALIASVALUE: aliasList[tempData?.trnData?.alias_type-1].code === 'MOBILE' ? '+994'+tempData?.trnData?.alias_value:tempData?.trnData?.alias_value
                    },
                    CUSTACC: findAccount?.IBAN
                },language)
                    .then(res=>{
                        if(res.ALIASRESULT==='Failure'){
                            setdisabledSign(true)
                            setInputDisabled(false)
                            setAliasError(res.ALIASREMARK)
                            form.setFieldsValue({
                                'BENEFNAME':'',
                                'BENEFBANKNAME':'',
                                'BENEFACC': '',
                                'BENEFBANKCODE':'',
                                'BENEFTAXID':'',


                            })
                            setInputValue('')
                            setGetbyAlias("N")
                        }

                        if(res.ALIASRESULT!=='Failure'){
                            form.setFieldsValue({
                                'BENEFNAME':res.BENEFINFO?.BENEFNAME,
                                'BENEFBANKNAME':res.BENEFINFO?.BENEFBANKNAME,
                                'BENEFACC': res.BENEFINFO?.BENEFACC,
                                'BENEFBANKCODE':res.BENEFINFO?.BENEFBANKCODE,
                                'BENEFTAXID':res.BENEFINFO?.BENEFTAXID

                            })

                            setBankTaxId(res.BENEFINFO?.BENEFBANKTAXID)
                            setBankCorAcc(res.BENEFINFO?.BENEFBANKCOREACC)
                            setBankSwift(res.BENEFINFO?.BENEFBANKSWIFT)

                            setGetbyAlias('Y')
                        }
                        setShowLoading(false)
                    })
                setAliasStatus(true)
            }
            else{
                let aliastype = aliasList.filter((item)=>item.label===tempData?.trnData?.alias_type)[0]?.value
                chooseAlisa(aliastype)
                setInputType(aliasList[aliastype-1].code)
                setSelectedAlias(aliasList[aliastype-1].value)
                form.setFieldsValue({
                    'alias_type':aliasList[aliastype-1].value
                })
                //ALIASVALUE
                form.setFieldsValue({
                    'alias_value':tempData?.trnData?.alias_value
                })
                getInfoByAlias({
                    PMTTYPECODE: "PI",
                    PMTID: tempData?.trnData?.PMTID,
                    CREATEDFROMTEMPL: "Y",
                    TEMPLATE: {
                        TEMPLNAME: tempData?.templateName
                    },
                    ALIAS: {
                        ALIASTYPE:aliasList[aliastype-1].code,
                        ALIASVALUE: aliasList[aliastype-1].code === 'MOBILE' ? '+994'+tempData?.trnData?.alias_value:tempData?.trnData?.alias_value
                    },
                    CUSTACC: findAccount?.IBAN
                },language)
                    .then(res=>{
                        if(res.ALIASRESULT==='Failure'){
                            setdisabledSign(true)
                            setInputDisabled(false)
                            setAliasError(res.ALIASREMARK)
                            form.setFieldsValue({
                                'BENEFNAME':'',
                                'BENEFBANKNAME':'',
                                'BENEFACC': '',
                                'BENEFBANKCODE':'',
                                'BENEFTAXID':'',


                            })
                            setInputValue('')
                            setGetbyAlias("N")
                        }

                        if(res.ALIASRESULT!=='Failure'){
                            form.setFieldsValue({
                                'BENEFNAME':res.BENEFINFO?.BENEFNAME,
                                'BENEFBANKNAME':res.BENEFINFO?.BENEFBANKNAME,
                                'BENEFACC': res.BENEFINFO?.BENEFACC,
                                'BENEFBANKCODE':res.BENEFINFO?.BENEFBANKCODE,
                                'BENEFTAXID':res.BENEFINFO?.BENEFTAXID

                            })

                            setBankTaxId(res.BENEFINFO?.BENEFBANKTAXID)
                            setBankCorAcc(res.BENEFINFO?.BENEFBANKCOREACC)
                            setBankSwift(res.BENEFINFO?.BENEFBANKSWIFT)

                            setGetbyAlias('Y')
                        }
                        setShowLoading(false)
                    })
                setAliasStatus(true)
            }
        }
        else{
            receiverDetailsbyIban(tempData?.trnData.BENEFACC)
            if (location.state?.data['BENEFACC'] !== undefined && location.state?.data['BENEFACC'] !== null) {
                receiverDetailsbyIban(location.state?.data['BENEFACC'])
                form.setFieldsValue({
                    'BENEFACC':tempData?.trnData.BENEFACC,
                    'BENEFNAME':tempData?.trnData.BENEFNAME,
                    'BENEFTAXID':tempData?.trnData.BENEFTAXID,
                    'BENEFBANKCODE':tempData?.trnData.BENEFBANKCODE,
                    'BENEFBANKNAME':tempData?.trnData.BENEFBANKNAME,
                })
            }
        }
        
        console.log(form.getFieldValue('PMTDET'))
        // COMISSION
        let valueA = checkAmountForRequest(tempData?.trnData.AMOUNT);


        if (!isNaN(valueA)) {
            setCommissionLoading(true);
            console.log(form.getFieldValue('PMTDET'))

            getCustomerCommission({
                PAYMENT_TYPE: "PI",
                CIF: getCurrentCompany().customerNo,
                CUSTACC: findAccount?.IBAN,
                AMOUNT: valueA,
                CUR: findAccount?.CCY_NAME,
                BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
                BENEFACC: tempData?.trnData.BENEFACC,
                BENEFTAXID: tempData?.trnData.BENEFTAXID === "" ? 0 :tempData?.trnData.BENEFTAXID ,
                PMTDET: tempData?.trnData.PMTDET!== undefined && tempData?.trnData.PMTDET?.length > 70 ?  tempData?.trnData.PMTDET?.substring(0,70) : (tempData?.trnData.PMTDET!==undefined ? tempData?.trnData.PMTDET: ''),

            }).then(res => {
                 // PMTDET
         console.log(form.getFieldValue('PMTDET'))
         if((tempData?.trnData.MAINDET !==undefined && tempData?.trnData.MAINDET  !==null)|| (tempData?.trnData.mainDetail !==undefined && tempData?.trnData.mainDetail  !==null && tempData?.trnData.mainDetail  !== "")){
            console.log(tempData?.trnData.MAINDET||tempData?.trnData.mainDetail)
            console.log(tempData?.trnData.PMTDET)
            form.setFieldsValue({
                'MAINDET': tempData?.trnData.MAINDET || tempData?.trnData.mainDetail
            });
            setMainDet(tempData?.trnData.MAINDET|| tempData?.trnData.mainDetail)
            if(tempData?.trnData.PMTDET?.includes(tempData?.trnData.MAINDET|| tempData?.trnData.mainDetail)) {
                const PMTDETAILWithoutMainDet = tempData?.trnData.PMTDET.replace(tempData?.trnData.MAINDET || tempData?.trnData.mainDetail, '').trim();
                console.log(
                    'isledi 560'
                )
                form.setFieldsValue({
                    'PMTDET':  PMTDETAILWithoutMainDet.length > 175 ? PMTDETAILWithoutMainDet.substring(0,175):PMTDETAILWithoutMainDet
                });
            }else{
                console.log(
                    'isledi 566'
                )
                form.setFieldsValue({
                    'PMTDET':tempData?.trnData?.PMTDET
                });
            }
        }else{
          
            if(tempData?.trnData.BENEFTAXID !== undefined && tempData?.trnData.BENEFTAXID !== null) {
                console.log(tempData?.trnData.PMTDET)
                form.setFieldsValue({
                    'PMTDET': tempData?.trnData.PMTDET
                });

                console.log(form.getFieldValue('PMTDET'))
            }else{
                form.setFieldsValue({
                    'PMTDET': tempData?.trnData.PMTDET.length > 175 ?  tempData?.trnData.PMTDET.substring(0,175): tempData?.trnData.PMTDET
                });
            }
            form.setFieldsValue({
                'MAINDET': undefined
            });
            setMainDet('')
        }

                setCommissionLoading(false);

                form.setFieldsValue({
                    'COMMAMOUNT': res.COM_AMOUNT ?? ''
                });
                setCommCode(res.CommCode ?? '')
                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
            })
        } else {
             // PMTDET
         console.log(form.getFieldValue('PMTDET'))
         if((tempData?.trnData.MAINDET !==undefined && tempData?.trnData.MAINDET  !==null)||(tempData?.trnData.mainDetail !==undefined && tempData?.trnData.mainDetail  !==null)){
            console.log(tempData?.trnData.MAINDET)
            console.log(tempData?.trnData.PMTDET)
            form.setFieldsValue({
                'MAINDET': tempData?.trnData.MAINDET|| tempData?.trnData.mainDetail
            });
            setMainDet(tempData?.trnData.MAINDET|| tempData?.trnData.mainDetail)
            if(tempData?.trnData.PMTDET?.includes(tempData?.trnData.MAINDET|| tempData?.trnData.mainDetail)) {
                const PMTDETAILWithoutMainDet = tempData?.trnData.PMTDET.replace(tempData?.trnData.MAINDET|| tempData?.trnData.mainDetail, '').trim();
                console.log(
                    'isledi 560'
                )
                form.setFieldsValue({
                    'PMTDET':  PMTDETAILWithoutMainDet.length > 175 ? PMTDETAILWithoutMainDet.substring(0,175):PMTDETAILWithoutMainDet
                });
            }else{
                console.log(
                    'isledi 566'
                )
                form.setFieldsValue({
                    'PMTDET':tempData?.trnData?.PMTDET
                });
            }
        }else{
          
            if(tempData?.trnData.BENEFTAXID !== undefined && tempData?.trnData.BENEFTAXID !== null) {
                console.log(tempData?.trnData.PMTDET)
                form.setFieldsValue({
                    'PMTDET': tempData?.trnData.PMTDET
                });

                console.log(form.getFieldValue('PMTDET'))
            }else{
                form.setFieldsValue({
                    'PMTDET': tempData?.trnData.PMTDET.length > 175 ?  tempData?.trnData.PMTDET.substring(0,175): tempData?.trnData.PMTDET
                });
            }
            form.setFieldsValue({
                'MAINDET': undefined
            });
            setMainDet('')
        }
            setCommissionLoading(false);
            console.log(form.getFieldValue('PMTDET'))

            form.setFieldsValue({
                'COMMAMOUNT': ''
            });

            setCommissionAmount(old_value => '');
        }
   
        console.log(form.getFieldValue('PMTDET'))
           
            setLoadingData(false)
     
    }


    const loadDataTemplate2 = async (tempData) => {
        console.log("loadDataTemplate2")
        setLoadingData(true)
        console.log("ads",tempData);
        setFileUp(tempData.trnData?.pdf_files);
        setGetbyTemp('Y')
        // load Account
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());
        let temp_data = [];
        for (let row of data) {
            if (row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        setLoadingAccount(false);


        // CUSTACC

        const findAccount = data?.find(row => row.IBAN === tempData?.trnData.CUSTACC);
        if (findAccount !== undefined) {
            setIsDisabled(false)
            setFromBranch(findAccount);
            if (form.getFieldValue('PMTID') === "" || form.getFieldValue('PMTID') === undefined) {
                updateDocumentNumber();
            }
            form.setFieldsValue({
                'CUSTACC': findAccount?.IBAN
            });
        }
        setcustAcc(findAccount?.IBAN)
        // BENEFACC

        // if (tempData?.trnData.BENEFACC !== undefined && tempData?.trnData.BENEFACC !== null) {
        //     const dataBENEFACC = await getTeskilatCodesByFilter(tempData?.trnData.BENEFACC, '');
        //     if (dataBENEFACC !== undefined && dataBENEFACC.length > 0) {
        //         setFormFields(old_data => ({
        //             ...old_data,
        //             BENEFBANKCODE: dataBENEFACC[0].code,
        //             BENEFACC: dataBENEFACC[0].orgcode,
        //
        //         }))
        //         setSelectedAccount(true);
        //     }
        // }
// ALIASTYPE


        setTempName(tempData?.templateName)
        setcustAcc(findAccount?.IBAN)
        //ALIASCheck
        if(tempData?.trnData?.alias_value !== null && tempData?.trnData?.alias_value !== '' && tempData?.trnData?.alias_value !== undefined){
            if(typeof tempData?.trnData?.alias_type !== 'string'){
                chooseAlisa(tempData?.trnData?.alias_type)
                setInputType(aliasList[tempData?.trnData?.alias_type-1].code)
                setSelectedAlias(aliasList[tempData?.trnData?.alias_type-1].value)
                form.setFieldsValue({
                    'alias_type':aliasList[tempData?.trnData?.alias_type-1].value
                })
                //ALIASVALUE
                form.setFieldsValue({
                    'alias_value':tempData?.trnData?.alias_value
                })
                getInfoByAlias({
                    PMTTYPECODE: "PI",
                    PMTID: tempData?.trnData?.PMTID,
                    CREATEDFROMTEMPL: "Y",
                    TEMPLATE: {
                        TEMPLNAME: tempData?.templateName
                    },
                    ALIAS: {
                        ALIASTYPE:aliasList[tempData?.trnData.alias_type-1].code,
                        ALIASVALUE: aliasList[tempData?.trnData?.alias_type-1].code === 'MOBILE' ? '+994'+tempData?.trnData?.alias_value:tempData?.trnData?.alias_value
                    },
                    CUSTACC: findAccount?.IBAN
                },language)
                    .then(res=>{
                        if(res.ALIASRESULT==='Failure'){
                            setdisabledSign(true)
                            setInputDisabled(false)
                            setAliasError(res.ALIASREMARK)
                            form.setFieldsValue({
                                'BENEFNAME':'',
                                'BENEFBANKNAME':'',
                                'BENEFACC': '',
                                'BENEFBANKCODE':'',
                                'BENEFTAXID':'',


                            })
                            setInputValue('')
                            setGetbyAlias("N")
                        }

                        if(res.ALIASRESULT!=='Failure'){
                            form.setFieldsValue({
                                'BENEFNAME':res.BENEFINFO?.BENEFNAME,
                                'BENEFBANKNAME':res.BENEFINFO?.BENEFBANKNAME,
                                'BENEFACC': res.BENEFINFO?.BENEFACC,
                                'BENEFBANKCODE':res.BENEFINFO?.BENEFBANKCODE,
                                'BENEFTAXID':res.BENEFINFO?.BENEFTAXID

                            })

                            setBankTaxId(res.BENEFINFO?.BENEFBANKTAXID)
                            setBankCorAcc(res.BENEFINFO?.BENEFBANKCOREACC)
                            setBankSwift(res.BENEFINFO?.BENEFBANKSWIFT)

                            setGetbyAlias('Y')
                        }
                        setShowLoading(false)
                    })
                setAliasStatus(true)
            }
            else{
                let aliastype = aliasList.filter((item)=>item.label===tempData?.trnData?.alias_type)[0]?.value
                chooseAlisa(aliastype)
                setInputType(aliasList[aliastype-1].code)
                setSelectedAlias(aliasList[aliastype-1].value)
                form.setFieldsValue({
                    'alias_type':aliasList[aliastype-1].value
                })
                //ALIASVALUE
                form.setFieldsValue({
                    'alias_value':tempData?.trnData?.alias_value
                })
                getInfoByAlias({
                    PMTTYPECODE: "PI",
                    PMTID: tempData?.trnData?.PMTID,
                    CREATEDFROMTEMPL: "Y",
                    TEMPLATE: {
                        TEMPLNAME: tempData?.templateName
                    },
                    ALIAS: {
                        ALIASTYPE:aliasList[aliastype-1].code,
                        ALIASVALUE: aliasList[aliastype-1].code === 'MOBILE' ? '+994'+tempData?.trnData?.alias_value:tempData?.trnData?.alias_value
                    },
                    CUSTACC: findAccount?.IBAN
                },language)
                    .then(res=>{
                        if(res.ALIASRESULT==='Failure'){
                            setdisabledSign(true)
                            setInputDisabled(false)
                            setAliasError(res.ALIASREMARK)
                            form.setFieldsValue({
                                'BENEFNAME':'',
                                'BENEFBANKNAME':'',
                                'BENEFACC': '',
                                'BENEFBANKCODE':'',
                                'BENEFTAXID':'',


                            })
                            setInputValue('')
                            setGetbyAlias("N")
                        }

                        if(res.ALIASRESULT!=='Failure'){
                            form.setFieldsValue({
                                'BENEFNAME':res.BENEFINFO?.BENEFNAME,
                                'BENEFBANKNAME':res.BENEFINFO?.BENEFBANKNAME,
                                'BENEFACC': res.BENEFINFO?.BENEFACC,
                                'BENEFBANKCODE':res.BENEFINFO?.BENEFBANKCODE,
                                'BENEFTAXID':res.BENEFINFO?.BENEFTAXID

                            })

                            setBankTaxId(res.BENEFINFO?.BENEFBANKTAXID)
                            setBankCorAcc(res.BENEFINFO?.BENEFBANKCOREACC)
                            setBankSwift(res.BENEFINFO?.BENEFBANKSWIFT)

                            setGetbyAlias('Y')
                        }
                        setShowLoading(false)
                    })
                setAliasStatus(true)
            }

        }else{
            receiverDetailsbyIban(tempData?.trnData.BENEFACC)
            form.setFieldsValue({
                'BENEFACC':tempData?.trnData.BENEFACC,
                'BENEFNAME':tempData?.trnData.BENEFNAME,
                'BENEFTAXID':tempData?.trnData.BENEFTAXID,
                'BENEFBANKCODE':tempData?.trnData.BENEFBANKCODE,
                'BENEFBANKNAME':tempData?.trnData.BENEFBANKNAME,
            })
        }
        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(tempData?.trnData.AMOUNT)
        });
       
        // NOTE
        form.setFieldsValue({
            'NOTE': tempData?.trnData.NOTE
        });

        // AMOUNT

        form.setFieldsValue({
            'INFOTOBENEF': tempData?.trnData.INFOTOBENEF
        });
        // COMISSION
        let valueA = checkAmountForRequest(tempData?.trnData.AMOUNT);

        if (!isNaN(valueA)) {
            setCommissionLoading(true);
            const res = await getCustomerCommission({
                PAYMENT_TYPE: "PI",
                CIF: getCurrentCompany().customerNo,
                CUSTACC: findAccount?.IBAN,
                AMOUNT: valueA,
                CUR: findAccount?.CCY_NAME,
                BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
                BENEFACC: tempData?.trnData.BENEFACC,
                BENEFTAXID: tempData?.trnData.BENEFTAXID,
                PMTDET: tempData?.trnData.PMTDET?.length > 70 ?  tempData?.trnData.PMTDET.substring(0,70) : tempData?.trnData.PMTDET
            })
            if (res !== undefined) {
                setCommissionLoading(false);

                form.setFieldsValue({
                    'COMMAMOUNT': res.COM_AMOUNT ?? ''
                });
                setCommCode(res.CommCode ?? '')
                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
            }
        } else {
            setCommissionLoading(false);

            form.setFieldsValue({
                'COMMAMOUNT': ''
            });

            setCommissionAmount(old_value => '');
        }

        // BENEFBANKCODE
        form.setFieldsValue({
            'BENEFBANKCODE': tempData?.trnData?.BENEFBANKCODE
        });

        //BENEFNAME

        form.setFieldsValue({
            'BENEFNAME': tempData?.trnData?.BENEFNAME
        });
        form.setFieldsValue({
            'BENEFTAXID': tempData?.trnData?.BENEFTAXID
        });

        // BENEFBANKNAME
        form.setFieldsValue({
            'BENEFBANKNAME': tempData?.trnData?.BENEFBANKNAME
        });
        //pmtdet
        // if(tempData?.trnData.PMTDET?.includes(tempData?.trnData.MAINDET)) {
        //     const PMTDETAILWithoutMainDet = tempData?.trnData.PMTDET.replace(tempData?.trnData.MAINDET, '').trim();
        //     form.setFieldsValue({
        //         'PMTDET': PMTDETAILWithoutMainDet
        //     });
        // }else{
        //     form.setFieldsValue({
        //         'PMTDET':tempData?.trnData.PMTDET
        //     });
        // }
         // PMTDET

         if((tempData?.trnData.MAINDET !==undefined && tempData?.trnData.MAINDET  !==null)|| (tempData?.trnData.mainDetail !==undefined && tempData?.trnData.mainDetail  !==null)){
            console.log(tempData?.trnData.MAINDET)
            console.log(tempData?.trnData.PMTDET)
            form.setFieldsValue({
                'MAINDET': tempData?.trnData.MAINDET||tempData?.trnData.mainDetail
            });
            setMainDet(tempData?.trnData.MAINDET||tempData?.trnData.mainDetail)
            if(tempData?.trnData.PMTDET?.includes(tempData?.trnData.MAINDET ||tempData?.trnData.mainDetail)) {
                const PMTDETAILWithoutMainDet = tempData?.trnData.PMTDET.replace(tempData?.trnData.MAINDET||tempData?.trnData.mainDetail, '').trim();
                console.log(
                    'isledi 560'
                )
                form.setFieldsValue({
                    'PMTDET':  PMTDETAILWithoutMainDet.length > 175 ? PMTDETAILWithoutMainDet.substring(0,175):PMTDETAILWithoutMainDet
                });
            }else{
                console.log(
                    'isledi 566'
                )
                form.setFieldsValue({
                    'PMTDET':tempData?.trnData?.PMTDET
                });
            }
        }else{
            console.log(
                'isledi 577'
            )
            console.log(tempData?.trnData.BENEFTAXID)
            if(tempData?.trnData.BENEFTAXID !== undefined && tempData?.trnData.BENEFTAXID !== null) {
            form.setFieldsValue({
                'PMTDET': tempData?.trnData.PMTDET?.trim()
            });
            }else{
            form.setFieldsValue({
                'PMTDET': tempData?.trnData.PMTDET.length > 175 ?  tempData?.trnData.PMTDET.substring(0,175)?.trim(): tempData?.trnData.PMTDET?.trim()
            });
            }
            form.setFieldsValue({
                'MAINDET': undefined
            });
            setMainDet('')
        }
        updateParentComponentFormData()
        setLoadingData(false)
    }

    const getSelectedFromBranch =async (value:any) => {
        console.log(form.getFieldValue('PMTDET'))
        // setGetbyTemp('N')
        setLoadingNext(false)
        setIsDisabled(true)
        setDisableCode(false)

        const findAccount=allAccounts?.find(row => row.ACCOUNT_NO==value || row.IBAN === value);

        console.log(form.getFieldValue('PMTDET'))

        if(findAccount !== undefined && findAccount !== null){
            setcustAcc(findAccount?.IBAN)
            setFromBranch(findAccount)
            const document_number = await getIpsNonBdgDocumentNumber(getCurrentCompany());
            form.setFieldsValue({
                'PMTID' : document_number
            });
            setDocumentNo(old_value => document_number)
            setIsDisabled(false)
        }else{
            setAliasStatus(false)
            setSelectedAlias(null)
        }
        console.log(form.getFieldValue('PMTDET'))

    }

    const resetFormFields = () => {
        setFormFields(old_data => {});
        form.resetFields(['BENEFNAME','alias_value','BENEFBANKCODE','BENEFACC'])
        // setFormFields(old_data => {});
        setInputValue(old_value => '');

        setInputPlaceholder(old_value => '');
        setAliasStatus(false);
        setStatusLimit('')
        setInputMask('')
        form.resetFields(
            ['PMTID']
        )
        setAccMessage(null)
        setMessage('')
        setNextModalVisible(false);
        setRetryRequest(null);
        setcustAcc('')
        setCommissionAmount('')
        setFromBranch(undefined)
        // form.resetFields(['showHideEdvBox']);
    }

    const onCloseSuccessModal = () => {
        resetForm(form);
        resetFormFields();
    }
    const updateParentComponentFormData = () => {
        if (ownProps?.getFormElements){
            ownProps?.getFormElements({form});
        }
    }

    useEffect(() => {
        if(ibanNumber.iban && allAccounts){
        const findAccount=allAccounts?.find(row => row.IBAN==ibanNumber.iban);
        setFromBranch(findAccount);

        setIbanNumber({iban: undefined, ccy_name: undefined})
        }

      }, [ibanNumber, allAccounts])
    const updateDocumentNumber = async () => {
        const document_number = await  getIpsNonBdgDocumentNumber(getCurrentCompany());

        form.setFieldsValue({
            'PMTID' : document_number
        });
        setDocumentNo(old_value => document_number)
    }


    const inputHandleChange = (e) => {
        setInputValue(e.target.value)
    }

    const updateAlias = (e) => {
        const checked=e.target.checked;
        setMessage('')
        setAliasError('')
        setAliasStatus(old_value => checked);
        setSelectedAlias(old_value => null)
        setInputPlaceholder(old_value => '')
        setInputValue('')
        setInputType('');
        setInputPrefix('');
        setInputMaxLength(false)
        setShowLoading(false);
        form.setFieldsValue({
            'BENEFNAME':'',
            'BENEFBANKNAME':'',
            'BENEFACC': '',
            'BENEFBANKCODE':'',
            'BENEFTAXID':'',
            'alias_value': ''

        })
    }

    const chooseAlisa = (value) => {
        setMessage('')
        setSelectedAlias(old_value => value)
        setInputValue(old_value => '');
        setInputPrefix('');
        setInputMaxLength(false);
        setShowLoading(false);
        setAliasError('');
        form.setFieldsValue({
            'BENEFNAME':'',
            'BENEFBANKNAME':'',
            'BENEFACC': '',
            'BENEFBANKCODE':'',
            'BENEFTAXID':'',
            'alias_value':''
        })

        if (value==1){
            setInputType('MOBILE');
            setInputMask('+994 (__) ___ __ __');
            setInputPlaceholder('(__) ___ __ __');
            setInputPrefix('+994');
            setInputMaxLength(9)

        }else if(value==2){
            setInputType('PIN');
            setInputMask('_______');
            setInputPlaceholder('_______');
            setInputMaxLength(7)

        }else if(value==3){
            setInputType('TIN');
            setInputMask('__________');
            setInputPlaceholder('__________');
            setInputMaxLength(10)

        }else if(value==4){
            setInputType('IBAN');
            setInputPlaceholder('');
            setInputMaxLength(28);

        }else if(value==5){
            setInputType('email');
            setInputPlaceholder('email@domen.abc');
            setInputMaxLength(1000)

        }else if(value==6){
            setInputType('MERCHANTID');
            setInputMask('____________________________');
            setInputPlaceholder('____________________________');
            setInputMaxLength(35)

        }else if(value==7){
            setInputType('OBJECTCODE');
            setInputMask('__________-_____');
            setInputPlaceholder('__________-_____');
            setInputMaxLength(16)
        }

    }

    const submitHandler = async (args: any) => {

        console.log("submitHandler isledi")
        setLoadingNext(true)
            await calculateCommission(args.AMOUNT);
            var res = await nextModalApi()


            console.log("nextModalApi=" + res)
           if(res?.LIMITMSGSTAT === 'Success'){
               await checkBenefAcc()
                setLoadingNext(false)

           }else{

               setLoadingNext(false)
               setlimitModal(true)
           }
            // await calculateCommission(args.AMOUNT);
            let pdf_files = form.getFieldValue('pdf_files') ?? [];
            modalDataInitial.pdfFiles = [];

            if (pdf_files.length > 0) {
                for (let file of pdf_files) {
                    modalDataInitial.pdfFiles.push({
                        label: file.name,
                        file: file
                    })

                }
            }

            //@ts-ignore
        setModalData((old_data: any) => {
            const mainDetail = form.getFieldValue('MAINDET');
            const pmtDetail = form.getFieldValue('PMTDET');
            const paymentDetails = args.MAINDET ? `${args.MAINDET} ${args.PMTDET || ""}` : args.PMTDET || "";


            return {
                ...modalDataInitial,
                groups: [
                    {
                        title: false,
                        tableHasBorderBottom: true,
                        data: [
                            {
                                label: t("transfers.sender"),
                                value: getCurrentCompany()?.name
                            },
                            {
                                label: t("salary.documentNo"),
                                value: form.getFieldValue('PMTID')
                            },
                            {
                                label: t("transfers.fromAccount"),
                                value: custAcc
                            }
                        ]
                    },
                    {
                        title: t("requisites.beneficiary"),
                        tableHasBorderBottom2: true,
                        tableHasMarginBottom: true,
                        data: [
                            {
                                label: t("transfers.identifierTypeANIPAY"),
                                value: aliasList.filter((item) => item.code === inputType)[0]?.label
                            },
                            {
                                label: t('transfers.identifierANIPAY'),
                                value: inputType === 'MOBILE' && !form.getFieldValue('alias_value').includes('994') ? inputPrefix + form.getFieldValue('alias_value') : form.getFieldValue('alias_value')
                            }
                        ]
                    },
                    {
                        title: false,
                        tableHasBorderBottom: true,
                        tableHasMarginBottom: true,
                        data: [
                            {
                                label: t("requisites.name"),
                                value: form.getFieldValue('BENEFNAME')
                            },
                            {
                                label: t("deposit.accountNumber"),
                                value: form.getFieldValue('BENEFACC')
                            },
                            {
                                label: t("requisites.taxID"),
                                value: form.getFieldValue('BENEFTAXID')
                            }
                        ]
                    },
                    {
                        title: t("requisites.beneficiaryBank"),
                        tableHasBorderBottom2: true,
                        tableHasMarginBottom: true,
                        data: [
                            {
                                label: t("requisites.code"),
                                value: form.getFieldValue('BENEFBANKCODE')
                            },
                            {
                                label: t("requisites.name"),
                                value: form.getFieldValue('BENEFBANKNAME')
                            }
                        ]
                    },
                    {
                        title: false,
                        data: [
                            {
                                label: t("common.amount"),
                                value: form.getFieldValue('AMOUNT')
                            },
                            {
                                label: t("home.commission"),
                                value: form.getFieldValue('COMMAMOUNT')
                            },
                            {
                                label: t("accountStatement.paymentDetails"),
                                value: paymentDetails
                            },
                            {
                                label: t("transfers.infoForBeneficiary"),
                                value: form.getFieldValue('INFOTOBENEF')
                            },
                            {
                                label: t("newTransfer.note"),
                                value: form.getFieldValue('NOTE')
                            }
                        ]
                    }
                ],
                note: messageCutOff,
                alertText: alertmessage,
            };
        });

        // cutOff()
    }

    const getFileList = (info : any) => {

        form.setFieldsValue({
            'pdf_files' : info.fileList
        });
    }

    const removeFile = (index:any)=>{
        const myNewFiles = [...fileList]
        myNewFiles.splice(index, 1);
        setFileList(myNewFiles)
    }
    const useDebouncedCommission = (calculateCommission: any) => {
  return useMemo(
    () =>
      debounce((value: string) => {
        if (value) {
          calculateCommission({ target: { value } });
        }
      }, 500),
    [calculateCommission]
  );
};
    const calculateCommission = async (e: any) => {
    setIsDisabled(true);
    let value;

    if (e?.target !== undefined) {
        value = checkAmountForRequest(e.target.value);
    } else {
        value = checkAmountForRequest(e);
    }

    if (!isNaN(value)) {
        try {
            setCommissionLoading(true);

            const res = await getCustomerCommission({
                PAYMENT_TYPE: "PI",
                CIF: getCurrentCompany().customerNo,
                CUSTACC: fromBranch?.IBAN,
                AMOUNT: value,
                CUR: fromBranch?.CCY_NAME,
                BENEFBANKCODE: form.getFieldValue('BENEFBANKCODE'),
                BENEFACC: form.getFieldValue('BENEFACC'),
                BENEFTAXID: form.getFieldValue('BENEFTAXID'),
                PMTDET: form.getFieldValue('PMTDET'),
            });

            setCurrency(res.CURRENCY);

            form.setFieldsValue({
                'COMMAMOUNT': res.COM_AMOUNT
            });

            setCommCode(res.CommCode);
            setCommissionAmount(res.COM_AMOUNT);
        } catch (error) {
            console.error("Commission fetch failed:", error);

            form.setFieldsValue({
                'COMMAMOUNT': ''
            });
            setCommissionAmount('');
        } finally {
            setCommissionLoading(false);
            setIsDisabled(false);
        }
    } else {
        setCommissionLoading(false);
        form.setFieldsValue({
            'COMMAMOUNT': ''
        });
        setCommissionAmount('');
        setIsDisabled(false);
    }
};

const debouncedCommission = useDebouncedCommission(calculateCommission);

    const openSaveAsTemplateModal = () => {

        setSaveAsTemplatePopupVisible(old_data => false)

        form.validateFields().then(res => {
            setSaveAsTemplatePopupVisible(old_data => true)

        }).catch(err_input_list => {

        })
    }

    const updateDocumentNumberAndCommission = (data) => {
        loadDataTemplate(data)
    }

    const checkAlias = () => {
        setShowLoading(true);
        // setInputDisabled(true)
        setAliasError('')

        getInfoByAlias(
            {
            PMTTYPECODE: "PI",
            PMTID: form.getFieldValue('PMTID'),
            CREATEDFROMTEMPL: getByTemp,
            TEMPLATE: {
                TEMPLNAME: tempName
            },
            ALIAS: {
                ALIASTYPE: inputType,
                ALIASVALUE: inputType === 'MOBILE' && !form.getFieldValue('alias_value').includes('994') ? '+994'+form.getFieldValue('alias_value'):form.getFieldValue('alias_value')
            },
            CUSTACC: custAcc
        },language
        ).then(res =>{
            if(res.ALIASRESULT==='Failure'){
                setdisabledSign(true)
                setInputDisabled(false)
                setAliasError(res.ALIASREMARK)
                // setInputValue('')
                setGetbyAlias("N")
                form.setFieldsValue({
                    'BENEFNAME':'',
                    'BENEFBANKNAME':'',
                    'BENEFACC': '',
                    'BENEFBANKCODE':'',
                    'BENEFTAXID':'',


                })
            }

            if(res.ALIASRESULT!=='Failure'){
                form.setFieldsValue({
                    'BENEFNAME':res.BENEFINFO?.BENEFNAME,
                    'BENEFBANKNAME':res.BENEFINFO?.BENEFBANKNAME,
                    'BENEFACC': res.BENEFINFO?.BENEFACC,
                    'BENEFBANKCODE':res.BENEFINFO?.BENEFBANKCODE,
                    'BENEFTAXID':res.BENEFINFO?.BENEFTAXID

                })

                setBankTaxId(res.BENEFINFO?.BENEFBANKTAXID)
                setBankCorAcc(res.BENEFINFO?.BENEFBANKCOREACC)
                setBankSwift(res.BENEFINFO?.BENEFBANKSWIFT)

                setGetbyAlias('Y')
                receiverDetailsbyIban(res.BENEFINFO?.BENEFACC)
                if(form.getFieldValue('AMOUNT')!==undefined){
                    console.log(amountField)
                    calculateCommission(amountField)
                }   
            }
            setShowLoading(false)
           
        })

    }

    const checkLimits = async () => {
        setLoadingLimit(true)

        var res = await checkLimit(
            {
            PMTTYPECODE: "PI",
            PMTID: form.getFieldValue('PMTID'),
            CREATEDFROMTEMPL: getByTemp,
            TEMPLATE: {
                TEMPLNAME: tempName
            },
            GETBYALIAS: getbyAlias,
            ALIAS: {
                ALIASTYPE: inputType,
                ALIASVALUE: inputPrefix+form.getFieldValue('alias_value')
            },
            CUSTACC: custAcc,
            CUSTACCAVLBALANCE: fromBranch?.BALANCE,
            CUSTACCFORCOM:  form.getFieldValue('COMMAMOUNT'),
            CUSTACCFORCOMCURR: currency,
            BENEFNAME: form.getFieldValue('BENEFNAME'),
            BENEFACC: form.getFieldValue('BENEFACC'),
            BENEFTAXID: form.getFieldValue('BENEFTAXID'),
            BENEFBANKCODE: form.getFieldValue('BENEFBANKCODE'),
            BENEFBANKNAME: form.getFieldValue('BENEFBANKNAME'),
            BENEFBANKTAXID: bankTaxId,
            BENEFBANKCORACC: bankCorAcc,
            BENEFBANKSWIFT: bankSwift,
            PMTAMOUNT: checkAmountForRequest(form.getFieldValue('AMOUNT')),
            COMMAMOUNT: form.getFieldValue('COMMAMOUNT'),
            BUDGETCLASSCODE: '',
            BUDGETCLASSCODENAME: "",
            BUDGETLEVELCODE: "",
            BUDGETLEVELCODENAME: "",
            PMTDET: form.getFieldValue('PMTDET'),
            INFOTOBENEF: form.getFieldValue('INFOTOBENEF'),
            NOTE: form.getFieldValue("NOTE")

        },language)
            const temp_array=[];
            const labelArray=[]
            if(res?.LIMITMSGSTAT === 'Success'){
                setStatusLimit('success')
                status_Limit == 'success'
            }else if(res?.LIMITMSGSTAT === 'Failure'){
                setStatusLimit('failure')
                status_Limit == 'failure'
                setdisabledSign(true)
            }else if (res?.LIMITMSGSTAT === 'Success' && res?.LIMITS?.keywordRestr ==='Found'){
                    setStatusLimit('failure')
                status_Limit == 'failure'
            }
            else{
                setStatusLimit('')
            }
            setModalNote(res?.LIMITKWRREMARK !== null ? res?.LIMITKWRREMARK:t("transfers.limitTimeOutError"))
        limitMessage=res?.LIMITKWRREMARK !== null ? res?.LIMITKWRREMARK:t("transfers.limitTimeOutError")
           res?.LIMITS?.limitInfo?.split(';').map((row)=>{
               labelArray.push(row.split(':')[0])
               temp_array.push(row.split(':')[1])
           })

            set2ndTitle(labelArray[5])

            setSentCariCount(temp_array[6])
            setTypeTransfer(temp_array[1])
            setCommissionAmountModal(temp_array[3])
            setAmountModal(temp_array[2])
            setAmountTransfer(temp_array[7])
            setCariCount(temp_array[8])
            setCariTotalAmount(temp_array[9])
            setLimitTotalAmount(temp_array[10])
            setLoadingLimit(false)

        return res;



    }

    const cutOff = async () => {
        setdisabledSign(true)
        var res = await cutOffService({
            PMTTYPECODE: "PI",
            PMTID: form.getFieldValue('PMTID'),
            CREATEDFROMTEMPL:getByTemp,
            TEMPLATE: {
                TEMPLNAME: tempName
            },
            GETBYALIAS: getbyAlias,
            ALIAS: {
                ALIASTYPE: inputType,
                ALIASVALUE: inputPrefix+form.getFieldValue('alias_value')
            },
            CUSTACC: custAcc,
            CUSTACCAVLBALANCE: fromBranch?.BALANCE,
            CUSTACCFORCOM: "",
            CUSTACCFORCOMCURR: "",
            BENEFNAME: form.getFieldValue('BENEFNAME'),
            BENEFACC: form.getFieldValue('BENEFACC'),
            BENEFTAXID: form.getFieldValue('BENEFTAXID'),
            BENEFBANKCODE: form.getFieldValue('BENEFBANKCODE'),
            BENEFBANKNAME: form.getFieldValue('BENEFBANKNAME'),
            BENEFBANKTAXID: bankTaxId,
            BENEFBANKCORACC: bankCorAcc,
            BENEFBANKSWIFT: bankSwift,
            PMTAMOUNT: checkAmountForRequest(form.getFieldValue('AMOUNT')),
            COMMAMOUNT: form.getFieldValue('COMMAMOUNT'),
            BUDGETCLASSCODE: '',
            BUDGETCLASSCODENAME: "",
            BUDGETLEVELCODE: "",
            BUDGETLEVELCODENAME: "",
            PMTDET: form.getFieldValue('PMTDET'),
            INFOTOBENEF: form.getFieldValue('INFOTOBENEF'),
            NOTE: form.getFieldValue("NOTE")
        },language);

        if(res.CUTOFFMSGSTAT === 'Success' && res.CUTOFF.isWorkingDay ==='Y' && res.CUTOFF.cutoffTime ==='Within'){
            setdisabledSign(false)
            setNextModalNote(res?.CUTOFFREMARK+'<br/>'+modalNote)
            messageCutOff = res?.CUTOFFREMARK+'<br/>'+limitMessage

        } else if(res.CUTOFFMSGSTAT === 'Success' && res.CUTOFF.isWorkingDay ==='Y' && res.CUTOFF.cutoffTime ==='Outof')
        {
            setdisabledSign(false)
            setAlertText(res?.CUTOFFREMARK)

            alertmessage = res?.CUTOFFREMARK
        } else if(res.CUTOFFMSGSTAT === 'Success' && res.CUTOFF.isWorkingDay ==='N' && res.CUTOFF.cutoffTime ==='Outof'){
            setdisabledSign(false)
            setAlertText(res?.CUTOFFREMARK)
            alertmessage = res?.CUTOFFREMARK

        }else if(res.CUTOFFMSGSTAT === 'Failure' ){
            setdisabledSign(true)
            setAlertText(res?.CUTOFFREMARK)
            alertmessage = res?.CUTOFFREMARK

        } else {
            setdisabledSign(true)
            setAlertText(t("transfers.cutOffError"))
            alertmessage = t("transfers.cutOffError")

        }

        setNextModalVisible(old_value => true);
    }

    const checkBenefAcc = async () =>{
        setdisabledSign(true)
        var res = await benefBankAccCheck({
            PMTTYPECODE: "PI",
            PMTID: form.getFieldValue('PMTID'),
            CREATEDFROMTEMPL: getByTemp,
            TEMPLATE: {
                TEMPLNAME: tempName
            },
            GETBYALIAS: getbyAlias,
            ALIAS: {
                ALIASTYPE: inputType,
                ALIASVALUE: inputPrefix+form.getFieldValue('alias_value')
            },
            CUSTACC: custAcc,
            CUSTACCAVLBALANCE: fromBranch?.BALANCE,
            CUSTACCFORCOM:  form.getFieldValue('COMMAMOUNT') ==="---"? 0 : form.getFieldValue('COMMAMOUNT'),
            CUSTACCFORCOMCURR: currency,
            BENEFNAME: form.getFieldValue('BENEFNAME'),
            BENEFACC: form.getFieldValue('BENEFACC'),
            BENEFTAXID: form.getFieldValue('BENEFTAXID'),
            BENEFBANKCODE: form.getFieldValue('BENEFBANKCODE'),
            BENEFBANKNAME: form.getFieldValue('BENEFBANKNAME'),
            BENEFBANKTAXID: bankTaxId,
            BENEFBANKCORACC: bankCorAcc,
            BENEFBANKSWIFT: bankSwift,
            PMTAMOUNT: checkAmountForRequest(form.getFieldValue('AMOUNT')),
            COMMAMOUNT:  form.getFieldValue('COMMAMOUNT') ==="---"? 0 : form.getFieldValue('COMMAMOUNT'),
            BUDGETCLASSCODE: '',
            BUDGETCLASSCODENAME: "",
            BUDGETLEVELCODE: "",
            BUDGETLEVELCODENAME: "",
            PMTDET: form.getFieldValue('PMTDET'),
            INFOTOBENEF: form.getFieldValue('INFOTOBENEF'),
            NOTE: form.getFieldValue("NOTE")
        },language);
        if(res.BENEFMSGSTAT === 'Failure' || res.BENEFMSGSTAT === null) {
            setNextModalVisible(false)
            setdisabledSign(true)
            setAccMessage(res?.BENEFREMARK)

        } else {
            await cutOff();
            setdisabledSign(false)
        }

    }

    const nextModalApi = async () => {
        console.log("nextModalApi isledi")
        const BENEFNAME= form.getFieldValue('BENEFNAME')
        const account_no = form.getFieldValue('BENEFACC')
        const bank_code = form.getFieldValue('BENEFBANKCODE')
        const bank_name = form.getFieldValue('BENEFBANKNAME')
        const amount = form.getFieldValue('AMOUNT')
        const voen = form.getFieldValue('BENEFTAXID')
        const maindet = form.getFieldValue('MAINDET')
        const pmtdet = form.getFieldValue('PMTDET')
        if(getbyAlias==='N') {
            setInputType('')
            form.setFieldsValue({
                'alias_value':'',
                'alias_type':''
            })
        }
        

        if(BENEFNAME !== undefined  && account_no!== undefined &&  amount !== undefined && bank_name !== undefined && bank_code !== undefined && (((voen === undefined || voen === '') && maindet !== undefined ) || (voen !== undefined && pmtdet!== undefined))){
        console.log('limit')
           
            return await checkLimits();

        }
    }

    const receiverDetailsbyIban=(value)=>{
        setAccMessage(null)

        if(form.getFieldValue('BENEFBANKCODE')=== '') {
            form.setFieldsValue({
                'BENEFBANKCODE': '',
                'BENEFBANKNAME': '',

            })
        }
        if(typeof value!=='string'){
            if(value.target.value.length>0){
                receiverDetail(value.target.value,language).then(resp=>{

                    if(resp[0].errorCode === "E001" ){
                        setIsDisabled(true)
                        setMessage(resp[0].errorDetail)
                    }else if(resp[0].errorCode==="IPS001"){
                        setIsDisabled(true)
                        setMessage(t("transfers.receiverDetailError"))

                    }else if(resp[0].errorCode==="IPS003"){
                        setIsDisabled(true)
                        setMessage(t("transfers.receiverDetailError3"))

                    }else if(resp[0].errorCode==="IPS005"){
                        setIsDisabled(true)
                        setMessage(t("transfers.receiverDetailError5"))

                    }else if(resp[0].errorCode==="IPS006"){
                        setIsDisabled(true)
                        setMessage(t("transfers.receiverDetailError"))

                    }
                    else{
                        if(!aliasStatus){
                            form.setFieldsValue({
                                'BENEFBANKCODE':resp[0].receiverBankCode,
                                'BENEFBANKNAME':resp[0].receiverBankName,

                            })
                        }

                        setBankTaxId(resp[0].receiverInn)
                        setBankSwift(resp[0].receiverBankBic )
                        setBankCorAcc(resp[0].receiverCorrespondentAccount)
                    }

                })
            }
        }else{
            if(value.length>0){
                receiverDetail(value,language).then(resp=>{

                    if(resp[0].errorCode === "E001" ){
                        setIsDisabled(true)
                        setMessage(resp[0].errorDetail)
                    }else if(resp[0].errorCode==="IPS001"){
                        setIsDisabled(true)
                        setMessage(t("transfers.receiverDetailError"))
                    }else if(resp[0].errorCode==="IPS003"){
                        setIsDisabled(true)
                        setMessage(t("transfers.receiverDetailError3"))
                    }else if(resp[0].errorCode==="IPS005"){
                        setIsDisabled(true)
                        setMessage(t("transfers.receiverDetailError5"))

                    }else if(resp[0].errorCode==="IPS006"){
                        setIsDisabled(true)
                        setMessage(t("transfers.receiverDetailError"))

                    }
                    else{
                        if(!aliasStatus){
                            form.setFieldsValue({
                                'BENEFBANKCODE':resp[0].receiverBankCode,
                                'BENEFBANKNAME':resp[0].receiverBankName,

                            })
                        }
                        setDisableCode(true)
                        setBankTaxId(resp[0].receiverInn)
                        setBankCorAcc(resp[0].receiverCorrespondentAccount)
                        setBankSwift(resp[0].receiverBankBic )
                    }

                })
            }
        }

    }

    const newTransfer =async (RequestType : string, retry : boolean = false) =>{
        let detail= form.getFieldValue('PMTDET') !== undefined ? form.getFieldValue('PMTDET'):''
       if(ibankRef !== "") {
              await   deleteFileById(ibankRef)
              await new Promise(res => setTimeout(res, 1000)); 
             }
        if (!retry) {
            const req = {
                "trnRequestType": RequestType,
                "PMTTYPECODE": "PI",
                "PMTCUSTID": form.getFieldValue("PMTID"),
                "PMTID": form.getFieldValue("PMTID"),
                "CREATEDFROMTEMPL": getByTemp,
                "TEMPLATE": {
                    "TEMPLNAME": tempName
                },
                "GETBYALIAS": getbyAlias,
                "ALIAS": {
                    "ALIASTYPE": inputType,
                    "ALIASVALUE": inputType === 'MOBILE' ? '+994' + form.getFieldValue('alias_value') : form.getFieldValue('alias_value'),
                },
                "CUSTACC": custAcc,
                "CUSTACCTYPE": " ",
                "CUSTACCAVLBALANCE": fromBranch?.BALANCE,
                "CUSTACCBRANCHCODE": '',
                "CUSTACCBRANCHCODECB": "",
                "CUSTACCFORCOM": "",
                "CUSTACCFORCOMCURR": "",
                "BENEFNAME": form.getFieldValue("BENEFNAME"),
                "BENEFACC": form.getFieldValue("BENEFACC"),
                "BENEFTAXID": form.getFieldValue("BENEFTAXID"),
                "BENEFBANKCODE": form.getFieldValue("BENEFBANKCODE"),
                "BENEFBANKNAME": form.getFieldValue("BENEFBANKNAME"),
                "BENEFBANKTAXID": bankTaxId,
                "BENEFBANKCORACC": bankCorAcc,
                "BENEFBANKSWIFT": bankSwift,
                "PMTAMOUNT": form.getFieldValue("AMOUNT"),
                "COMMAMOUNT": form.getFieldValue("COMMAMOUNT"),
                "BUDGETCLASSCODE": "",
                "BUDGETCLASSCODENAME": "",
                "BUDGETLEVELCODE": "",
                "BUDGETLEVELCODENAME": "",
                "PMTDET": form.getFieldValue('BENEFTAXID')===null || form.getFieldValue('BENEFTAXID')===undefined || form.getFieldValue('BENEFTAXID')=== '' ? form.getFieldValue('MAINDET')+" "+detail : form.getFieldValue('PMTDET'),
                "mainDetail": form.getFieldValue('BENEFTAXID') === null || form.getFieldValue('BENEFTAXID') === undefined || form.getFieldValue('BENEFTAXID') === '' ? maindetail : "",
                "INFOTOBENEF": form.getFieldValue("INFOTOBENEF"),
                "NOTE": form.getFieldValue("NOTE"),
                "CommCode": commCode ,
                "ibankRef": ibankRef,
            }

            setRetryRequest(req);
            const data = IpsNewTransfer(req,language);
            return data;
        }else{
            if(retryRequest !== null)
                retryRequest['trnRequestType'] = RequestType;
            const data  = IpsNewTransfer(retryRequest,language);
            return data;
        }
    }
    const handleMainDet= (value:any)=>{
        setMainDet(value)
        setIsTouched(true);
        setHasError(value === null || value === undefined );


    }
   
    return (
        <>
            <Row >
                <Col flex={'700px'}  className="own-account">
                    <Card bordered={false}>
                        <Row justify='start' className="own-account__form">
                            <Form
                                labelCol={{ flex: '190px'}}
                                wrapperCol={{ flex: 1 }}
                                className='full'
                                onFinish={submitHandler}
                                id={'form'}
                                onValuesChange={updateParentComponentFormData}
                                form={form}
                                autoComplete="off"
                                scrollToFirstError={{
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'center',
                                }}
                            >
                                { !addOrEditPage && <div className='flex ' >
                                    <InputField
                                        labelItem={t("salary.documentNo")}
                                        placeholder={t("salary.automatically")}
                                        name={'PMTID'}
                                        required={true}
                                        message={true}
                                        value={documentNo}
                                        form={form}
                                        maxLength={25}
                                        allowLatinNumber ={true}
                                    />

                                    <Button
                                        size={'large'}
                                        icon={<SaveIco />}
                                        className="blue-button transfer__button flex align_center justify_center create_tr_template_btn"
                                        onClick={e => setTemplatePopupVisible(true)}
                                    >
                                        {OWNACCOUNT.PATTERN}
                                    </Button>
                                </div>
                                }
                                <SelectField
                                    labelItem={t("transfers.fromAccount")}
                                    placeholder={t("accountStatement.chooseAccount")}
                                    options={fromSelectOptions}
                                    name={'CUSTACC'}
                                    value={custAcc}
                                    onChange={getSelectedFromBranch}
                                    required={true}
                                    form={form}
                                    account={true}
                                    notFoundContent={!loadingAccount ? t("newTransfer.noAccountCorrespondingCurrency") : undefined }
                                    defaultValue={ibanNumber.ccy_name?.toString()?.toLowerCase() === 'azn' && ibanNumber.iban}
                                />


                                <Divider plain orientation="left" className={'tab_divider_left'} >{t("common.beneficiary")}</Divider>

                                <div  className={'flex align_center'}>
                                    <div className={'tab_form_label ant-form-item-label '} style={{marginTop : '-10px'}}>
                                        <label>{t('transfers.identifierANIPAY')}</label>
                                    </div>

                                    <Col flex="20px" className={'ant-form-item flex' } >
                                        <Checkbox
                                            form={form}
                                            name={'alias_check'}
                                            onChange={updateAlias}
                                            disabled={!fromBranch?.ACCOUNT_NO}
                                            checked={aliasStatus}
                                        />
                                    </Col>

                                    <Col flex="130px" style={{marginLeft : 10, width :130}} >
                                        <SelectField
                                            labelCol={{ span: 7 }}
                                            labelItem=""
                                            placeholder={aliasStatus ? t("transfers.anipayType") : ' '}
                                            options={aliasList}
                                            disabled={!aliasStatus}
                                            onChange={chooseAlisa}
                                            value={selectedAlias}
                                            form={form}
                                            name={'alias_type'}
                                            readOnly={inputDisabled}
                                            className={'isReadOnly'}
                                        />
                                    </Col>

                                    <Col flex="309px" style={{marginLeft : 10}}>
                                        <InputField
                                            labelCol={{ span: 7 }}
                                            labelItem=""
                                            allowLatinWithSomeSymbols={true}
                                            placeholder={inputPlaceholder}
                                            disabled={!aliasStatus|| (aliasStatus && !selectedAlias) || (aliasStatus && selectedAlias === '')}
                                            type={inputType}
                                            mask={inputMask}
                                            prefix={inputPrefix}
                                            onlyNumberandSomesymbol={ selectedAlias===7 }
                                            onlyNumberandLowEng={selectedAlias === 6}
                                            email={selectedAlias===5}
                                            objectCode={selectedAlias === 7}
                                            onlyNumberAndUpEng= {selectedAlias === 2 || selectedAlias === 4}
                                            onlyNumber={selectedAlias === 1 || selectedAlias === 3 }
                                            // value={inputValue}
                                            onChange={inputHandleChange}
                                            maxLength={inputMaxLength}
                                            form={form}
                                            name={'alias_value'}
                                            onBlur={checkAlias}
                                            // readOnly={inputDisabled}
                                            className={'isDisabled'}
                                            showMessage={aliaserrorMessage !== '' ?? true}
                                            message={aliaserrorMessage}
                                        />
                                        {/*<InputAniPay*/}
                                        {/*    labelCol={{span: 7}}*/}
                                        {/*    onChange={inputHandleChange}*/}
                                        {/*    onBlur={checkAlias}*/}
                                        {/*    form={form}*/}
                                        {/*    placeholder={inputPlaceholder}*/}
                                        {/*    disabled={!aliasStatus|| (aliasStatus && !selectedAlias) || (aliasStatus && selectedAlias === '')}*/}
                                        {/*    showMessage={aliaserrorMessage !== '' ?? true}*/}
                                        {/*    message={aliaserrorMessage}*/}
                                        {/*    // type={inputType}*/}
                                        {/*    // prefix={inputPrefix}*/}
                                        {/*    name={'alias_value'}*/}
                                        {/*    className={'isDisabled'}*/}
                                        {/*    phone={selectedAlias == 1}*/}
                                        {/*    voen={selectedAlias == 3 || selectedAlias == 7}*/}
                                        {/*    pincode={selectedAlias == 2 || selectedAlias == 4}*/}
                                        {/*    merchant={selectedAlias == 6}*/}
                                        {/*    mail={selectedAlias == 5}*/}
                                        {/*    mask={inputMask}*/}
                                        {/*/>*/}
                                    </Col>

                                    {showLoading && <Button type={'ghost'} className={'transparent alias_loading'} icon={<SpinnerIco />} /> }

                                </div>
                                {/*{!aliasStatus && <span style={{color:'#F3646C'}}>{aliaserrorMessage}</span>}*/}
                                <Divider className='no_text' />

                                <TextAreaField
                                    visible={true}
                                    labelItem={t("requisites.name")}
                                    placeholder={t("newTransfer.nameBeneficiary")}
                                    showCount={true}
                                    maxLength={140}
                                    readOnly={aliasStatus ||  !fromBranch?.ACCOUNT_NO}
                                    allowLatin={true}
                                    required={true}
                                    form={form}
                                    name={'BENEFNAME'}
                                    disabled={aliasStatus ||  !fromBranch?.ACCOUNT_NO}
                                    className={'isDisabled'}
                                />
                                {
                                    accMessage !== '' && <span className={'form_error_span3'}>{accMessage}</span>
                                }
                                <InputField   ////
                                    labelItem={t("deposit.accountNumber")}
                                    placeholder=""
                                    name={'BENEFACC'}
                                    className={'is_upper_case isDisabled'}
                                    maxLength={'28'}
                                    readOnly={aliasStatus ||  !fromBranch?.ACCOUNT_NO}
                                    showMessage={message!== ''??true}
                                    message={message}
                                    disabled={aliasStatus ||  !fromBranch?.ACCOUNT_NO}
                                    onBlur={receiverDetailsbyIban}
                                    onKeyUp={()=>{setMessage('')}}
                                    form={form}
                                    upper={true}
                                    required={true}
                                    allowLatin={true}
                                    account={true}
                                />

                                <InputField
                                    labelItem={t("requisites.taxID")}
                                    placeholder=""
                                    required={false}
                                    readOnly={aliasStatus ||  !fromBranch?.ACCOUNT_NO}
                                    isNumeric={true}
                                    onlyNumber={true}
                                    maxLength={'10'}
                                    form={form}
                                    disabled={aliasStatus ||  !fromBranch?.ACCOUNT_NO}
                                    name={'BENEFTAXID'}
                                    className={'isDisabled'}
                                />

                                <Divider plain orientation="left" className={'tab_divider_left'} >
                                    {t("newTransfer.beneficiaryBank")}
                                    <Tooltip
                                        overlayClassName={'tabs_tooltip'}
                                        placement={"top"}
                                        title={`Ödəniş tapşırığı Alias vasitəsilə yaradarkən, alanın bankı barəsində məlumat avtomatik olaraq doldurulur!`}>
                                        <Button
                                            type={'ghost'}
                                            className={'transparent divider_tooltip_btn'}
                                            icon={<TabsInfoIco />}

                                        />
                                    </Tooltip>
                                </Divider>

                                <div className='flex'>
                                    <InputField
                                        labelItem={t("requisites.code")}
                                        // placeholder={t("newTransfer.atLeast2Char")}
                                        allowClear={true}
                                        readOnly={true}
                                        required={true}
                                        maxLength={6}
                                        isNumeric={true}
                                        onlyNumber={true}
                                        form={form}
                                        name={'BENEFBANKCODE'}
                                        disabled={true}
                                        value={formFields?.BENEFBANKCODE}
                                        className={'not_show_required_props isReadOnly'}
                                        onKeyUp={() => { updateBankCodes(false) }}
                                        autoComplete={true}
                                        options={bankCodes}
                                        filterRowClick={updateToBankCodeAndName}
                                    />


                                </div>

                                <InputField
                                    labelItem={t("requisites.name")}
                                    placeholder=""
                                    className="not-required isReadOnly"
                                    readOnly={true}
                                    required={false}
                                    allowLatin={true}
                                    form={form}
                                    name={'BENEFBANKNAME'}
                                    value={formFields?.BENEFBANKNAME}
                                />

                                <Divider className='no_text' />

                                <div className={'flex relative'}  >
                                    <AmountField
                                        labelItem={t("common.amount")}
                                        placeholder=""
                                        suffix={'AZN'}
                                        name={'AMOUNT'}
                                        className={'amount_and_commission_col amount_input amount_input_width_btn isDisabled'}
                                        required={true}
                                        form={form}
                                        onChange={(e)=>{
                                            setAmount(e.target.value);
                                            debouncedCommission(e.target.value);
                                        }}
                                        // onChange={()=>setIsDisabled(true)}
                                        disabled={!fromBranch?.ACCOUNT_NO}
                                        // onBlur={calculateCommission}
                                    />

                                    <Col className={'commission_col mobile-select'} >
                                        <InputField
                                            labelCol={2}
                                            labelItem={t("home.commission")}
                                            placeholder=""
                                            className="dark-input commission_input commission_input_with_btn isDisabled"
                                            readOnly={true}
                                            suffix="AZN"

                                            customClass={'custom_anipay_spin'}
                                            name={'COMMAMOUNT'}
                                            value={commissionAmount}
                                            hasLoading={commissionLoading}
                                            form={form}
                                        />
                                    </Col>

                                    <Col flex={'72px'} style={{marginLeft : 10}} >
                                        <Button
                                            size={"large"}
                                            className={'blue-button btn flex align_center justify_center'}
                                            disabled={!form.getFieldValue("CUSTACC")}
                                            onClick={()=>{checkLimits();setlimitModal(true)}}
                                            loading={loadinglimit}

                                        >{t("businessCards.limits")}</Button>
                                    </Col>
                                    {/*{loadinglimit && <Button type={'ghost'} className={'transparent alias_loading '} icon={<SpinnerIco />} /> }*/}
                                    {
                                        limitModal && !loadinglimit &&
                                        <LimitsModal
                                        visible={limitModal}
                                        onOk={()=>setlimitModal(false)}
                                        onCancel={()=>setlimitModal(false)}
                                        data={modalDataLimit}

                                        />

                                    }
                                    <div className={'flex align_center limit_buttons'} >
                                        {statusLimit !== '' ?

                                                statusLimit === 'success' ?
                                                    <Button type={"ghost"} className={'transparent flex align_center justify_center limit_success_ico'} icon={<CheckGreenIco />} /> :
                                                <Button type={"ghost"} className={'transparent flex align_center justify_center limit_cancel_ico'} icon={<CancelRedIco />} /> : <></>

                                        }


                                    </div>
                                </div>

                                { form.getFieldValue('BENEFTAXID')===null || form.getFieldValue('BENEFTAXID')===undefined || form.getFieldValue('BENEFTAXID')=== '' ?
                                    <div> <Form.Item
                                        label={t("accountStatement.mainPayment")}
                                        name={'MAINDET'}
                                        form={form}
                                        rules={[
                                            {
                                                required: true,
                                                message: t("newTransfer.requiredField"),

                                            },
                                        ]}
                                        validateTrigger="onBlur"
                                    >
                                        <Select
                                            status={hasError && isTouched ? 'error' : ''}
                                            style={{
                                                width: '100%',

                                            }}
                                            onChange={(value: string) => handleMainDet(value)}
                                            size="large"
                                            value={maindetail}
                                            // required={true}
                                            placeholder={t("transfers.select")}
                                            disabled={!fromBranch}
                                            options={optionsDet}
                                            loading={dropListLoading}

                                        />

                                    </Form.Item>
                                        <TextAreaField
                                            visible={true}
                                            labelItem={t("accountStatement.additionalPaymentDetails")}
                                            placeholder=""
                                            showCount={true}
                                            maxLength={'175'}
                                            name={'PMTDET'}
                                            required={false}
                                            message={t("newTransfer.requiredField")}
                                            form={form}
                                            allowLatin={true}
                                            readOnly={!fromBranch?.ACCOUNT_NO}
                                            className={''}
                                        />
                                    </div>
                                    : <TextAreaField
                                        visible={true}
                                        labelItem={t("accountStatement.paymentDetails")}
                                        placeholder=""
                                        showCount={true}
                                        maxLength={'210'}
                                        name={'PMTDET'}
                                        required={true}
                                        form={form}
                                        // allowDestination={true}
                                        allowLatin={true}
                                        disabled={!fromBranch?.ACCOUNT_NO}
                                        className={'isDisabled'}
                                    />}


                                <TextAreaField
                                    visible={true}
                                    labelItem={t("transfers.infoForBeneficiary")}
                                    placeholder=""
                                    showCount={true}
                                    maxLength={'560'}
                                    allowLatin={true}
                                    name={'INFOTOBENEF'}
                                    className={'no_required isDisabled'}
                                    form={form}
                                    readOnly={!fromBranch?.ACCOUNT_NO}

                                />

                                <div className={'flex'}>
                                    <Col flex={1}>
                                        <TextAreaField
                                            visible={visible}
                                            className='not-required isDisabled'
                                            labelItem={t("newTransfer.note")}
                                            placeholder={t("newTransfer.notTransferableToBank")}
                                            showCount={true}
                                            maxLength={'180'}
                                            name={'NOTE'}
                                            form={form}
                                            // allowAllSymboll={true}
                                            exchangeNote={true}

                                            readOnly={!fromBranch?.ACCOUNT_NO}
                                            disabled={!fromBranch?.ACCOUNT_NO}
                                        />
                                    </Col>
                                    <Button
                                        className="icon-button add-remove-btn"
                                        icon={visible ? <MinusSmallIco /> : <PlusSmallIco />}
                                        onClick={() => setVisible(!visible)}
                                    />
                                </div>

                                <FileUpload
                                    className='file-upload isDisabled'
                                    labelItem={t("newTransfer.attachPDF")}
                                    form={form}
                                    fileLimit={10}
                                    checkSize={true}
                                    name={'pdf_files'}
                                    onChange={getFileList}
                                    editFileList={fileList}
                                    accept="application/pdf"
                                    multiple={false}
                                    required={false}
                                    removeFile={removeFile}
                                    tempFileList={fileUp}
                                    disabled={!fromBranch?.ACCOUNT_NO}
                                />

                                { !addOrEditPage &&<div  className='flex button_row' >
                                    <Button
                                        size={'large'}
                                        icon={<SaveBlueIco />}
                                        className="light-button btn save_btn flex align_center justify_center"
                                        htmlType={"button"}
                                        onClick={openSaveAsTemplateModal}

                                    >
                                        {OWNACCOUNT.SAVE}
                                    </Button>

                                    <div className={'flex flex_wrap'}>
                                        <Button

                                            size={'large'}
                                            icon={<RefreshIco />}
                                            className="light-button refresh_btn btn flex align_center justify_center"
                                            onClick={(e) => {resetFormFields();resetForm(form); }}
                                        >
                                            {t(OWNACCOUNT.REFRESH)}
                                        </Button>

                                        <Button
                                            size={'large'}
                                            htmlType="submit"
                                            disabled={isDisabled}
                                            className="blue-button next_btn btn flex align_center justify_center"
                                            loading={loadingNext}

                                        >
                                            {OWNACCOUNT.NEXT}
                                        </Button>


                                    </div>

                                </div>
                                }
                            </Form>
                        </Row>
                    </Card>
                </Col>
            </Row>

            <NextModal
                errorIcon={<EroorIco />}
                callBackApi={newTransfer}
                visible={nextModalVisible}
                onCloseSuccessModal={onCloseSuccessModal}
                data={modalData}
                className={'no_footer_line'}
                currentForm={form}
                repeatPdfList={fileList}
                transfer={true}
                disabled={disabledSign}
                anipay={true}
                onClose= {() => {setNextModalVisible(false); setRetryRequest(null);}}
                editTransfer={ibankRef !== undefined && ibankRef !== '' && ibankRef !== null}


            />

            <TemplatePopup
                visible={templatePopupVisible}
                onClose={setTemplatePopupVisible}
                trnType={'IPS_OTH'}
                currentForm={form}
                // setFileList = {setFileUp}
                updateAfterTemplate={updateDocumentNumberAndCommission}
            />

            <SaveAsTemplate
                visible={saveAsTemplatePopupVisible}
                onClose={setSaveAsTemplatePopupVisible}
                trnType={'IPS_OTH'}
                currentForm={form}
            />
            {
                loadingData ? <FullScreenLoading /> : <></>
            }
        </>
    )
}

const mapDispatchToProps = {setIbanNumber}

const mapStateToProps = (state: any,ownProps:any) => ({
    ownProps: ownProps,
    ibanNumber: (state.accountsStatement && state.accountsStatement.ibanNumber) ? state.accountsStatement.ibanNumber : {}
});

export default connect(mapStateToProps, mapDispatchToProps)(QeyriBudce)
